import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @typedef {import('types').User} UserModel
 */
import api from 'lib/api';
import { http, onMsalTokenError } from 'lib/msal';
import { appInsights, setEnhancedLogLevel } from 'lib/appInsights';
import getEnvironment from 'lib/env';
export var SET_USER = 'SET_USER';
export var GET_TENANT = 'GET_TENANT';
export var USER_ROLES = 'USER_ROLES';
export var CURRENT_USER = 'CURRENT_USER';
export var CURRENT_USER_BASE = 'CURRENT_USER_BASE';
export var SET_ROLE = 'SET_ROLE';
export var SET_SCHOOL = 'SET_SCHOOL';
export var SET_SCHOOL_TYPE = 'SET_SCHOOL_TYPE';
export var SEARCH_USER = 'SEARCH_USER';
export var CLEAR_SEARCH_USER = 'CLEAR_SEARCH_USER';
export var GET_USER_INFO = 'GET_USER_INFO';
export var SET_ACTIVE_TEAMS_TAB = 'SET_ACTIVE_TEAMS_TAB';
export var SET_LANGUAGE = 'SET_LANGUAGE';
export var GET_TENANT_SCHOOLS = 'GET_TENANT_SCHOOLS';
export var USER_GET_USER_ABSENCE = 'USER_GET_USER_ABSENCE';
export var USER_GET_MENTOR_SECTION = 'USER_GET_MENTOR_SECTION';
export var GET_USER_GUARDIAN = 'GET_USER_GUARDIAN';
export var GET_GUARDIAN_BY_EMAIL = 'GET_GUARDIAN_BY_EMAIL';
export var GET_GUARDIAN_BY_ID = 'GET_GUARDIAN_BY_ID';
export var SET_GUARDIAN_BY_ID = 'SET_GUARDIAN_BY_ID';
export var SET_USER_GUARDIAN = "SET_USER_GUARDIAN";
export var ADD_USER_GUARDIAN = "ADD_USER_GUARDIAN";
export var DELETE_USER_GUARDIAN = "ADD_USER_GUARDIAN";
export var SET_USER_AUTHORITATIVE = "SET_USER_AUTHORITATIVE";
export var GET_READER_PARAMS = 'USER_GET_IMMERSIVE_READER_PARAMETERS';
export var GET_USER_COURSES = 'GET_STUDENT_COURSES';
export var GET_USER_SUBJECTS = 'GET_STUDENT_SUBJECTS';
export var SEARCH_STAFF = 'SEARCH_STAFF';
export var UPDATE_USER = 'UPDATE_USER';
export var GET_USER_FILES = 'USER_GET_USER_FILES';
export var DELETE_USER_FILE = 'USER_DELETE_USER_FILE';
export var UPDATE_USER_FILE = 'USER_UPDATE_USER_FILES';
export var LINK_STUDENT_GUARDIAN = 'LINK_STUDENT_GUARDIAN';
export var ADD_USER_ROLE = 'ADD_USER_ROLE';
export var DELETE_USER_ROLE = 'DELETE_USER_ROLE';
export var GET_TEACHER_ROLES = 'GET_TEACHER_ROLES';
export var DELETE_TEACHER_ROLE = 'DELETE_TEACHER_ROLE';
export var ADD_TEACHER_ROLE = "ADD_TEACHER_ROLE";
export var GET_USER_SECTIONS = 'SECTIONS_GET_USER_SECTIONS';
export var GET_MY_MENTOR_SECTIONS = 'SECTIONS_GET_MY_USER_SECTIONS';
export var GET_USERS_WITHOUT_MENTOR_GROUPS = 'USERS_GET_USERS_WITHOUT_MENTOR_GROUPS';
export var USER_ADMIN_CHECK = 'USER_ADMIN_CHECK';
export var ADD_USER = 'ADD_USER';
export var GET_MY_SECTIONS = 'USERS_GET_MY_SECTIONS';
export var GET_ALL_SECTIONS = 'GET_ALL_SECTIONS';
export var GET_ALL_USER_SECTIONS = 'GET_ALL_USER_SECTIONS';
export var USER_SCOPES_VERIFICATION = 'USER_SCOPES_VERIFICATION';
export var GET_USER_ACCESSTOKEN = 'GET_USER_ACCESSTOKEN';
export function addUserRole(userId, roleId) {
  return {
    type: ADD_USER_ROLE,
    payload: new Promise(function (resolve, reject) {
      api.put("users/".concat(userId, "/roles/").concat(roleId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function deleteUserRole(userId, roleId) {
  return {
    type: DELETE_USER_ROLE,
    payload: new Promise(function (resolve, reject) {
      api["delete"]("users/".concat(userId, "/roles/").concat(roleId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function setActiveTeamsTab(tab) {
  return {
    type: SET_ACTIVE_TEAMS_TAB,
    payload: tab
  };
}
export function setUser(user) {
  return {
    type: SET_USER,
    payload: user
  };
}
export function setActiveRole(role) {
  return {
    type: SET_ROLE,
    payload: role
  };
}
export function setActiveSchool(school) {
  return {
    type: SET_SCHOOL,
    payload: school
  };
}
export function setSchoolType(type) {
  return {
    type: SET_SCHOOL_TYPE,
    payload: type
  };
}
export function getTenant() {
  return {
    type: GET_TENANT,
    payload: new Promise(function (resolve, reject) {
      api.get('tenants/educationBackendBaseUrl', true).then(function (response) {
        var environment = getEnvironment();

        if (environment != null && environment.type == "staging" && response.data != null) {
          http.defaults.baseURL = "https://hapi-prod-staging.appservice.han.cygatemas.se/api/";
        } else if (response.data != null) {
          http.defaults.baseURL = response.data;
        }
      }).then(function () {
        api.get('tenants').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error.status);
        });
      });
    })
  };
}
export function userAdminCheck() {
  return {
    type: USER_ADMIN_CHECK,
    payload: new Promise(function (resolve) {
      api.get('services/me/checkadmin').then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function verifyUserScopes(userId, scopes) {
  return {
    type: USER_SCOPES_VERIFICATION,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/scope-verification?scopes=").concat(scopes)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function getTenantSchools() {
  return {
    type: GET_TENANT_SCHOOLS,
    payload: new Promise(function (resolve) {
      api.get('tenants/expand').then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function getUserRoles(userId) {
  return {
    type: USER_ROLES,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/roles")).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function getBaseMe() {
  return {
    type: CURRENT_USER_BASE,
    payload: new Promise(function (resolve, reject) {
      api.get('users/me/base').then(function (response) {
        /**
         * @type {UserModel} response.data
         */
        resolve(response.data);
      })["catch"](function (error) {
        if (error.response.data != null) {
          if (error.response.data.errorCode != null) {
            if (error.response.data.errorCode == 'invalid_grant') {
              onMsalTokenError(null, error);
            }
          }
        }

        reject(error);
      });
    })
  };
}
export function getMe() {
  return {
    type: CURRENT_USER,
    payload: new Promise(function (resolve, reject) {
      api.get('users/me').then(function (response) {
        var _response$data;

        appInsights.trackTrace({
          message: 'EDU022 | UserRoles'
        }, (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.roles);
        /**
         * @type {UserModel} response.data
         */

        resolve(response.data);
      })["catch"](function (error) {
        if (error.response == null) {
          return false;
        }

        if (error.response.data != null) {
          if (error.response.data.errorCode != null) {
            if (error.response.data.errorCode == 'invalid_grant') {
              onMsalTokenError(null, error);
            }

            if (error.response.data.errorCode == 'interaction_required') {
              setEnhancedLogLevel(1);
              onMsalTokenError(null, error);
              appInsights.trackTrace({
                message: 'EDU014 | Got interaction_required errorCode from graph'
              });
            }
          }

          reject(error.response);
          return false;
        }

        reject(0);
      });
    })
  };
}
var infoIds = [];
export function getUserInfo(id) {
  var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: GET_USER_INFO,
    payload: new Promise(function (resolve, reject) {
      if (infoIds.indexOf(id) == -1 && !update || update) {
        if (infoIds.indexOf(id) == -1) infoIds.push(id);
        api.get("users/".concat(id, "?returnType=").concat(returnType)).then(function (response) {
          resolve(response.data);
        });
      } else {
        resolve(null);
      }
    })
  };
}
export function searchUser(name, schoolId) {
  return {
    type: SEARCH_USER,
    payload: new Promise(function (resolve) {
      var url = "users?search=".concat(name, "&userType=student");

      if (name == '' || name == null) {
        resolve([]);
        return true;
      }

      api.get(url).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function clearSearchUser() {
  return {
    type: CLEAR_SEARCH_USER,
    payload: null
  };
}
export function setLanguage(lcid) {
  return {
    type: SET_LANGUAGE,
    payload: new Promise(function (resolve) {
      api.put("users/me/lcid/".concat(lcid)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export var getUserAbsence = function getUserAbsence(id, start, end) {
  return {
    type: USER_GET_USER_ABSENCE,
    payload: new Promise(function (resolve) {
      var url = "users/".concat(id, "/absence/");

      if (start != null && end != null) {
        url = "users/".concat(id, "/absence?start=").concat(start, "&end=").concat(end);
      }

      api.get(url).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getMentorSections = function getMentorSections(userId) {
  return {
    type: USER_GET_MENTOR_SECTION,
    payload: new Promise(function (resolve) {
      api.get("sections?userId=".concat(userId, "&type=MENTOR_GROUP&includeMemberGroups=false")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export function getUserGuardian(id) {
  return {
    type: GET_USER_GUARDIAN,
    payload: new Promise(function (resolve, reject) {
      api.get("users/".concat(id, "/guardians")).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function getUserGuardianByEmail(email) {
  return {
    type: GET_GUARDIAN_BY_EMAIL,
    payload: new Promise(function (resolve, reject) {
      api.get("users/guardians?email=".concat(email)).then(function (response) {
        if (response.status > 300) {
          reject('error');
        }

        resolve(response.data);
      });
    })
  };
}
export function getOnBehalfOfAccessToken(id, scopes) {
  return {
    type: GET_USER_ACCESSTOKEN,
    payload: new Promise(function (resolve, reject) {
      api.get("users/".concat(id, "/access_token?scopes=").concat(scopes)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function getGuardianById(id) {
  return {
    type: GET_GUARDIAN_BY_ID,
    payload: new Promise(function (resolve, reject) {
      api.get("users/guardians/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function setUserGuardian(userId, guardian) {
  return {
    type: SET_USER_GUARDIAN,
    payload: new Promise(function (resolve, reject) {
      api.put("users/".concat(userId, "/guardians"), guardian).then(function (response) {
        if (response.status > 300) {
          reject('error');
        }

        resolve(response.data);
      });
    })
  };
}
export function setGuardian(id, guardian) {
  return {
    type: SET_GUARDIAN_BY_ID,
    payload: new Promise(function (resolve, reject) {
      api.put("users/guardians/".concat(id), guardian).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function addUser(userItem) {
  var preOnboarding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: ADD_USER,
    payload: new Promise(function (resolve, reject) {
      api.post("users?preOnboarding=" + preOnboarding, userItem).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export function addUserGuardian(userId, guardian) {
  return {
    type: ADD_USER_GUARDIAN,
    payload: new Promise(function (resolve, reject) {
      api.post("users/".concat(userId, "/guardians"), guardian).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export var deleteStudentGuardian = function deleteStudentGuardian(userId, guardianId, removeAll) {
  return {
    type: DELETE_USER_GUARDIAN,
    payload: new Promise(function (resolve) {
      api["delete"]("users/".concat(userId, "/guardians/").concat(guardianId, "?removeAll=").concat(removeAll)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var linkStudentGuardian = function linkStudentGuardian(userId, guardianId) {
  return {
    type: LINK_STUDENT_GUARDIAN,
    payload: new Promise(function (resolve) {
      api.put("users/".concat(userId, "/guardians/").concat(guardianId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var setUserAuthoritative = function setUserAuthoritative(userId, authoritative) {
  return {
    type: SET_USER_AUTHORITATIVE,
    payload: new Promise(function (resolve, reject) {
      api.put("users/".concat(userId, "/authoritative/").concat(authoritative)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export function getReaderParameters() {
  return {
    type: GET_READER_PARAMS,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
        var token, subdomain;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.get("cognitiveServices/token");

              case 2:
                token = _context.sent;
                _context.next = 5;
                return api.get("cognitiveServices/subdomain");

              case 5:
                subdomain = _context.sent;
                resolve({
                  subdomain: subdomain.data,
                  token: token.data
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  };
}
export var getUserCourses = function getUserCourses(userId) {
  return {
    type: GET_USER_COURSES,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/courses")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getUserSubjects = function getUserSubjects(userId) {
  return {
    type: GET_USER_SUBJECTS,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/subjects")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export function updateUser(user) {
  return {
    type: UPDATE_USER,
    payload: new Promise(function (resolve) {
      api.put("users/".concat(user.userId), user).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export var getTeacherRoles = function getTeacherRoles(userId) {
  return {
    type: GET_TEACHER_ROLES,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/teacherroles")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var deleteTeacherRole = function deleteTeacherRole(userId, SubjectCode, schoolId) {
  return {
    type: DELETE_TEACHER_ROLE,
    payload: new Promise(function (resolve) {
      api["delete"]("users/".concat(userId, "/teacherroles/").concat(SubjectCode, "?schoolId=").concat(schoolId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export function addTeacherRole(userId, subjectTeacher) {
  return {
    type: ADD_TEACHER_ROLE,
    payload: new Promise(function (resolve, reject) {
      api.post("users/".concat(userId, "/teacherroles"), subjectTeacher).then(function (response) {
        resolve(response.data);
      });
    })
  };
}
export var getUserFiles = function getUserFiles(userId) {
  return {
    type: GET_USER_FILES,
    payload: new Promise(function (resolve) {
      api.get("users/".concat(userId, "/files")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var updateUserFile = function updateUserFile(userId, file) {
  return {
    type: UPDATE_USER_FILE,
    payload: new Promise(function (resolve) {
      api.put("users/".concat(userId, "/files/").concat(file.id), file).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var deleteUserFile = function deleteUserFile(userId, fileId) {
  return {
    type: DELETE_USER_FILE,
    payload: new Promise(function (resolve, reject) {
      api["delete"]("users/".concat(userId, "/files/").concat(fileId)).then(function (response) {
        resolve(fileId);
      })["catch"](function () {
        reject(0);
      });
    })
  };
};
export var getUserSections = function getUserSections(userId) {
  return {
    type: GET_USER_SECTIONS,
    payload: new Promise(function (resolve) {
      api.get("sections?type=EDUCATION_GROUP&includeHistorical=true&includeMemberGroups=true&userId=".concat(userId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getAllUserSections = function getAllUserSections(userId, parameters) {
  return {
    type: GET_ALL_USER_SECTIONS,
    payload: new Promise(function (resolve) {
      var url = '';

      var urlParams = _objectSpread({
        pageSize: 20,
        pageIndex: 1,
        filter: '',
        sortBy: 'TITLE_DESC'
      }, parameters);

      for (var key in urlParams) {
        url += "&".concat(key, "=").concat(urlParams[key]);
      }

      api.get("users/".concat(userId, "/sections?_=").concat(url)).then(function (response) {
        resolve(_objectSpread({
          documents: response.data
        }, urlParams));
      });
    })
  };
};
export var getMyMentorSections = function getMyMentorSections() {
  return {
    type: GET_MY_MENTOR_SECTIONS,
    payload: new Promise(function (resolve) {
      api.get("users/me/sections?type=MENTOR_GROUP").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getUsersWithoutMentorGroups = function getUsersWithoutMentorGroups() {
  return {
    type: GET_USERS_WITHOUT_MENTOR_GROUPS,
    payload: new Promise(function (resolve) {
      api.get("users/withoutmentorgroups").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var updateUserPhoneNumber = function updateUserPhoneNumber(user) {
  return {
    type: UPDATE_USER,
    payload: new Promise(function (resolve) {
      api.put("users/".concat(user.id, "/phonenumber"), user).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getMySections = function getMySections(parameters) {
  return {
    type: GET_MY_SECTIONS,
    payload: new Promise(function (resolve) {
      var url = '';

      var urlParams = _objectSpread({
        pageSize: 20,
        pageIndex: 1,
        filter: '',
        sortBy: 'TITLE_DESC'
      }, parameters);

      for (var key in urlParams) {
        url += "&".concat(key, "=").concat(urlParams[key]);
      }

      api.get("users/me/sections?_=".concat(url)).then(function (response) {
        resolve(_objectSpread({
          documents: response.data
        }, urlParams));
      });
    })
  };
};
export var getAllSections = function getAllSections(parameters) {
  return {
    type: GET_ALL_SECTIONS,
    payload: new Promise(function (resolve) {
      var url = '';

      var urlParams = _objectSpread({
        pageSize: 20,
        pageIndex: 1,
        filter: '',
        sortBy: 'TITLE_DESC'
      }, parameters);

      for (var key in urlParams) {
        url += "&".concat(key, "=").concat(urlParams[key]);
      }

      api.get("schools/sections?_=".concat(url)).then(function (response) {
        resolve(_objectSpread({
          documents: response.data
        }, urlParams));
      });
    })
  };
};